'use strict';
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/deprecation-decorator/node_modules/core-js/internals/hidden-keys.js
// module id = 2807
// module chunks = 25